// Bundle F-1 — the one roles vocabulary (frontend mirror of backend config/roles.py).
// RULE: New role names are added here first; no new role === checks anywhere else.

export const APP_OWNER = "owner";
export const DEV_ADMIN = "admin";
export const ORG_ADMIN = "org_admin";
export const ORG_MEMBER = "org_member";
export const WORKSPACE_ROLES = ["admin", "member", "viewer"];

const isOwner = (user) => !!user?.isShadowOwner;

// Mirrors config/roles.py: manage_app / view_owner_metrics → owner; use_dev_console → admin or owner; edit_app_config → admin.
export function can(user, action) {
  if (!user) return false;
  switch (action) {
    case "manage_app":
    case "view_owner_metrics":
      return isOwner(user);
    case "use_dev_console":
      return user.role === DEV_ADMIN || isOwner(user);
    case "edit_app_config":
      return user.role === DEV_ADMIN;
    default:
      return false;
  }
}
